import { useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import FullInfoBox from '../components/FullInfoBox';
import AdSpace from '../components/AdSpace';
import { useNavigate } from 'react-router-dom';
import { newsService } from '../../firebase/services';
import stockBall from '../icons/stock_ball.jpg';

export default function HomePage() {
  const [recentNews, setRecentNews] = useState([]);
  const [highlightedNews, setHighlightedNews] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const loadNews = async () => {
      try {
        const newsData = await newsService.getAllNews();
        const recent = newsData.slice(0, 3);
        let highlighted = newsData.filter(news => news.isHighlighted).slice(0, 3);
        
        if (highlighted.length < 3) {
          const highlightedIds = highlighted.map(news => news.id);
          const remainingRecent = newsData.filter(news => !highlightedIds.includes(news.id));
          const needed = 3 - highlighted.length;
          highlighted = [...highlighted, ...remainingRecent.slice(0, needed)];
        }
        
        setRecentNews(recent);
        setHighlightedNews(highlighted);
      } catch (error) {
        console.error('Erro ao carregar notícias:', error);
        setRecentNews([]);
        setHighlightedNews([]);
      }
    };

    loadNews();
    
    const handleNewsUpdated = () => loadNews();
    window.addEventListener('newsUpdated', handleNewsUpdated);
    return () => window.removeEventListener('newsUpdated', handleNewsUpdated);
  }, []);

  return (
    <Box
      sx={{
        width: '100%',
        margin: { xs: 0, sm: 1, md: 2 },
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <AdSpace 
        height="100px"
        sx={{ 
          marginBottom: 3,
          maxWidth: '100%'
        }}
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 2,
          alignItems: { xs: 'center', md: 'flex-start' },
        }}
      >
        <Box sx={{ flex: 2, maxWidth: '880px'}}>
          <FullInfoBox
            headerText="Notícias Recentes"
            mainNews={recentNews[0] ? {
              ...recentNews[0],
              mediaUrl: recentNews[0].mediaUrl || stockBall
            } : {
              id: null,
              title: "Procurando notícias...",
              subtitle: "Aguarde enquanto carregamos as últimas notícias esportivas",
              mediaUrl: stockBall
            }}
            sideNews1={recentNews[1] ? {
              ...recentNews[1],
              mediaUrl: recentNews[1].mediaUrl || stockBall
            } : {
              id: null,
              title: "Mais notícias em breve",
              subtitle: "Acompanhe as últimas novidades do mundo esportivo",
              mediaUrl: stockBall
            }}
            sideNews2={recentNews[2] ? {
              ...recentNews[2],
              mediaUrl: recentNews[2].mediaUrl || stockBall
            } : {
              id: null,
              title: "Mais notícias em breve",
              subtitle: "Acompanhe as últimas novidades do mundo esportivo",
              mediaUrl: stockBall
            }}
          />
        </Box>
        <Box sx={{
          flex: 1,
          minWidth: 240,
          maxWidth: 300,
          display: 'flex',
          gap:2 ,
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
          mt: { xs: 2, md: 2 },
          ml:{ xs: 0, md: 2 },
          mb: { xs: 3, md: 0 },
          borderRadius:2,
          background: 'linear-gradient(to bottom, #e0e0e0 0%, rgba(255,255,255,0) 100%)',
        }}>
            <Button
              fullWidth
              sx={{
                mt:2, 
                fontWeight: 'bold', 
                color:"GrayText", 
                fontSize:16,
                '&:hover': {
                  color: 'steelblue',
                }
              }}
              onClick={() => navigate('/news-list')}
            >
              Ver todas as notícias
            </Button>
            <Button
              color="primary"
              fullWidth
              sx={{
                fontWeight: 'bold', 
                color:"GrayText", 
                fontSize:16,
                '&:hover': {
                  color: 'steelblue',
                }
              }}
              onClick={() => navigate('/news-list?tab=1')}
            >
              Ver todos os destaques
            </Button>
            <Box sx={{height: 32}}></Box>
          </Box>
      </Box>

      <AdSpace 
        height="90px"
        sx={{ 
          marginY: 3,
          maxWidth: '880px'
        }}
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 2,
          alignItems: { xs: 'center', md: 'flex-start' },
        }}
      >
        <Box sx={{ flex: 2, maxWidth: '880px'}}>
          <FullInfoBox
          bgFilter='hue-rotate(160deg)'
          headerText="Destaques"
          headerColor="darkOrange"
          mainNews={highlightedNews[0] ? {
            ...highlightedNews[0],
            mediaUrl: highlightedNews[0].mediaUrl || stockBall
          } : {
            id: null,
            title: "Nenhum destaque no momento",
            subtitle: "Em breve traremos os principais destaques esportivos",
            mediaUrl: stockBall
          }}
          sideNews1={highlightedNews[1] ? {
            ...highlightedNews[1],
            mediaUrl: highlightedNews[1].mediaUrl || stockBall
          } : {
            id: null,
            title: "Mais destaques em breve",
            subtitle: "Fique ligado para mais notícias em destaque",
            mediaUrl: stockBall
          }}
          sideNews2={highlightedNews[2] ? {
            ...highlightedNews[2],
            mediaUrl: highlightedNews[2].mediaUrl || stockBall
          } : {
            id: null,
            title: "Mais destaques em breve",
            subtitle: "Fique ligado para mais notícias em destaque",
            mediaUrl: stockBall
          }}
        />
        </Box>
      </Box>
    </Box>
  );
}
